import { AuthWrapper } from "@client/components/auth/AuthWrapper";
import { Providers } from "@client/providers";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
	component: Root,
});

function Root() {
	return (
		<Providers>
			<div className="bg-neutral-50 text-base text-neutral-900 antialiased transition-colors selection:bg-blue-700 selection:text-white dark:bg-neutral-950 dark:text-neutral-100">
				<AuthWrapper>
					<Outlet />
				</AuthWrapper>
			</div>
		</Providers>
	);
}
